import * as React from "react";
const SvgCross = props => <svg width={50} height={50} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M48.333 48.333 1.667 1.667m46.666 0L1.667 48.333" stroke="#04080F" strokeWidth={3} strokeLinecap="round" /></svg>;
export default SvgCross;